module.exports = __webpack_public_path__ + "img/calenderGrey.fef493e4.svg";